import { Illustration, Typography } from "@saviynt/design-system";

interface EmptyStateProps {
  message?: string;
}

export default function EmptyState({
  message = "No data found",
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center p-12">
      <Illustration kind="Empty" />
      <Typography kind="h3" className="mt-4">
        {message}
      </Typography>
    </div>
  );
}
